import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { AccordionComponent } from 'components/accordion/accordion.component';
import { WorkitemActivityIndicatorModule } from 'shared/components/workitem-activity-indicator/workitem-activity-indicator.module';
import { WorkItemListModule } from 'components/accordion/workitem-list/workitem-list.module';
import { SearchWidgetModule } from 'components/accordion/search-widget/search-widget.module';
import { AgentStatsModule } from './agent-stats/agent-stats.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    WorkitemActivityIndicatorModule,
    WorkItemListModule,
    SearchWidgetModule,
    AgentStatsModule
  ],
  declarations: [
    AccordionComponent
  ],
  exports: [
    AccordionComponent
  ]
})
export class AccordionModule {}
